import TaskForm from "./TaskForm";
import "./styles.scss";

export default { TaskForm };
